import React from 'react';
import { FormInput } from "components/form"
import { DefaultLength, ComposeValidators, Required } from "validators";

function EducationForm() {
   return (
      <>
         <FormInput validate={ ComposeValidators(Required, DefaultLength) } name="school" label="School" type="text" />
         <FormInput validate={ ComposeValidators(Required, DefaultLength) } name="degree" label="Degree" type="text" />
         <FormInput validate={ ComposeValidators(Required, DefaultLength) } name="field" label="Field" type="text" />
         <FormInput validate={ ComposeValidators(Required, DefaultLength) } name="started" label="Started" type="text" />
         <FormInput validate={ ComposeValidators(Required, DefaultLength) } name="ended" label="Ended" type="text" />
         <FormInput validate={ ComposeValidators(DefaultLength) } name="extra" label="Extra" type="text" />
      </>
   )
}

export default EducationForm;
